export default __webpack_public_path__ + "static/media/fdp (1).85a1ad7c.jpeg";